import { render, staticRenderFns } from "./IpotekForm.vue?vue&type=template&id=56805a62"
import script from "./IpotekForm.vue?vue&type=script&lang=ts"
export * from "./IpotekForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports